module.exports = __webpack_public_path__ + "img/wfqwt-nav.d807c09.svg";